import * as React from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { supabaseClient } from "@/lib/supabase/client";
import { TODO } from "@revelate/types";
import { OtpDialog } from "./otp-dialog";
import { Loader } from "@/components/Loader";
import { getMagicLinkRedirectUrl } from "../auth-redirect";

interface UserAuthFormProps extends React.HTMLAttributes<HTMLDivElement> { }

export function UserAuthForm({ className, ...props }: UserAuthFormProps) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);
  const [email, setEmail] = React.useState<string>("");

  const signIn = async (email: string) => {
    if (!email) return;
    setIsLoading(true);
    const { error } = await supabaseClient.auth.signInWithOtp({
      email: email.trim(),
      options: {
        emailRedirectTo: getMagicLinkRedirectUrl({
          currentPath: window.location.pathname,
          currentSearch: window.location.search,
          siteUrl: import.meta.env.VITE_SITE_URL || window.location.origin,
        }),
      },
    });
    setIsLoading(false);
    if (error) {
      console.log("Error signing in", error);
    } else {
      setDialogOpen(true);
    }
  };

  async function onSubmit(event: React.SyntheticEvent) {
    event.preventDefault();
    const email = (event.target as TODO)["email"].value;
    setEmail(email);
    signIn(email);
  }

  return (
    <div className={cn("grid gap-6", className)} {...props}>
      <form onSubmit={onSubmit}>
        <div className="grid gap-4">
          <div className="grid gap-2">
            <Label htmlFor="email">Work Email</Label>
            <Input
              required
              id="email"
              placeholder="name@example.com"
              type="email"
              autoCapitalize="none"
              autoComplete="email"
              autoCorrect="off"
              disabled={isLoading}
            />
          </div>
          <Button disabled={isLoading} style={{ backgroundColor: "#6B6397" }}>
            {isLoading && (
              <Loader size={16} stroke="white" className="mr-2" />
            )}
            Continue
          </Button>
        </div>
      </form>
      <OtpDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        email={email}
        signIn={signIn}
      />
    </div>
  );
}
